/**
 * Shared by dead-link and LCP-element telemetry, which both reduce a raw URL
 * to a PostHog-safe property. A query string or hash can carry signed params,
 * tokens, or user input, so neither ever leaves the browser — origin+pathname
 * is all the insight needs.
 */
import { logger } from '@lib/logger'

/** Parses `raw` against `base`, returning null instead of throwing on anything unparseable. */
export function parseUrl(raw: string, base?: string): URL | null {
  try {
    return new URL(raw, base)
  } catch (err) {
    logger.error('posthog-ingest', 'unparseable URL in telemetry payload', err)
    return null
  }
}

/** Origin + pathname, with the query string and hash stripped. */
export function originPathname(url: URL): string {
  return url.origin + url.pathname
}
